import gql from 'graphql-tag';

export default gql`
  fragment eventFragment on EventType {
    id
    groupId
    title
    description
    eventDate
    eventDatetimeText
    eventDateText
    eventDateWday
    startTimeText
    mainImage
    mainImageUrl
    eventStatus
    eventStatusText
    paymentStatus
    paymentStatusText
    akerunStatus
    akerunStatusText
    locationType
    locationTypeText
    location
    ticketQuantity
    ticketAmount
    isFree
    dueDate
    dueDateText
    dueTime
    dueTimeText
    address
    organizer
    informationEmail
    informationTel
    acmPrice
    taxAcmPrice
    guestCount
    cancelDate
    cancelDateText
    cancelTime
    cancelTimeText
    canCancel
    onShowpage
    isShowEventList
    eventType
    eventTypeText
    chargeId
    ticketPaymentMethod
    ticketPaymentMethodText
    ownerPaymentStatus
    ownerPaymentStatusText
    isReceipt
    receiptName
    ownerPaymentDate
    receiptStatus
    receiptStatusText
    orderCount
    totalSalesPrice
    totalFee
    totalPaymentPrice
  }
`;
